"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localStorageTokensResolvingStrategy = void 0;
var local_storage_service_1 = require("../../../local-storage-service");
var models_1 = require("../models");
var getToken = function (tokenType) {
    return local_storage_service_1.authSuiteLocalStorageService.getItem(tokenType) || null;
};
var execute = function () {
    var applicationAccessToken = getToken(models_1.TokenType.APPLICATION_ACCESS_TOKEN);
    var deviceRefreshToken = getToken(models_1.TokenType.DEVICE_REFRESH_TOKEN);
    return Promise.resolve(applicationAccessToken || deviceRefreshToken
        ? {
            applicationAccessToken: applicationAccessToken,
            deviceRefreshToken: deviceRefreshToken,
        }
        : null);
};
exports.localStorageTokensResolvingStrategy = {
    execute: execute,
};
